import React, { useEffect, useState } from 'react';
import client from '../../api/client';

export default function AutoDeclineRuns() {
  const [runs, setRuns] = useState([]);
  useEffect(() => { client.get('/admin/auto-decline-runs').then(({ data }) => setRuns(data.runs)).catch(() => {}); }, []);
  return (
    <section data-testid="admin-auto-decline-runs" className="mt-6 bg-white rounded-2xl border border-[#EFE3D8] p-5">
      <h3 className="font-serif text-xl text-[#2A2A2A] mb-3">Auto-decline runs</h3>
      {runs.length === 0 ? <p className="text-sm text-[#9A8A7E]">No runs yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#9A8A7E]"><th className="pb-2">Ran</th><th>Couple</th><th>Reply-by</th><th>Declined</th><th>Texted</th><th>Emailed</th><th>Failed</th><th>Waiting</th></tr></thead>
            <tbody>
              {runs.map((r) => (
                <tr key={r.id} data-testid={`admin-run-${r.id}`} className="border-t border-[#F2E8DE] align-top">
                  <td className="py-2 pr-3 whitespace-nowrap text-xs">{new Date(r.ran_at).toLocaleString()}</td>
                  <td className="py-2 pr-3 text-xs">{r.email}</td>
                  <td className="py-2 pr-3 text-xs">{r.reply_by || '—'}</td>
                  <td className="py-2 pr-3">{r.declined}</td>
                  <td className="py-2 pr-3">{r.sms_sent}</td>
                  <td className="py-2 pr-3">{r.email_sent}</td>
                  <td className="py-2 pr-3 text-red-700" title={(r.failures || []).map((f) => `${f.guest}: ${f.errors.join('; ')}`).join('\n')}>{r.failed}</td>
                  <td className="py-2">{Math.max(0, r.queued - (r.dispatched || 0))}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
